module.exports = __webpack_public_path__ + "img/Agriculture.11e5dc42.jpg";